export enum ApiStatus {
    IDLE = 'IDLE',
    RUNNING = 'RUNNING',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR'
}